module.exports = __webpack_public_path__ + "static/media/ticket.405eed48.svg";